export default __webpack_public_path__ + "static/media/css.138cbd18.jpeg";